import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { KpiReportFilter } from '../../../../common/dtos/reports.dto';
import {
  reportingPdSessionAttendanceDTOFromApiResponse,
  reportingPdSessionSummaryDTOFromApiResponse,
} from '../../helpers/translators/reporting.translators';
import {
  ReportingPdSessionAttendanceItemAPIResponse,
  ReportingPdSessionSummaryItemAPIResponse,
} from '../../types/responses/reporting.responses';

@Injectable({
  providedIn: 'root',
})
export class ReportPdSessionSummaryService {
  public sessionName = '';

  constructor(private apiService: APICoreService) {}

  getPdSessionSummary(
    filters: KpiReportFilter[],
    page = 1,
    sort_by = '',
    sort_by_desc = 0,
    per_page = 10,
    report = 'pdSessionSummary',
    reportFiltersetId?: number | null
  ) {
    const params: Record<string, unknown> = {
      page,
      sort_by,
      sort_by_desc,
      per_page,
      report,
    };
    if (reportFiltersetId) {
      params['report_filterset_id'] = reportFiltersetId;
    } else {
      params['filters'] = filters;
    }
    return this.apiService.getRequest('reporting/load-report', params).pipe(
      map((res) => {
        if (res.items) {
          res.items = res.items.map(
            (item: ReportingPdSessionSummaryItemAPIResponse) =>
              reportingPdSessionSummaryDTOFromApiResponse(item)
          );
        }
        return res;
      })
    );
  }

  getPdSessionAttendance(
    filters: KpiReportFilter[],
    page = 1,
    sort_by = '',
    sort_by_desc = 0,
    per_page = 10,
    report = 'pdStaffMemberSessionAttendance',
    reportFiltersetId?: number | null
  ) {
    const params: Record<string, unknown> = {
      page,
      sort_by,
      sort_by_desc,
      per_page,
      report,
    };
    if (reportFiltersetId) {
      params['report_filterset_id'] = reportFiltersetId;
    } else {
      params['filters'] = filters;
    }
    return this.apiService.getRequest('reporting/load-report', params).pipe(
      map((res) => {
        if (res.items) {
          res.items = res.items.map(
            (item: ReportingPdSessionAttendanceItemAPIResponse) =>
              reportingPdSessionAttendanceDTOFromApiResponse(item)
          );
        }
        if (res.session_name) {
          this.sessionName = res.session_name;
        }
        return res;
      })
    );
  }

  queueDownloadReport(
    filters: KpiReportFilter[],
    report?: { title: string; report: string }
  ) {
    const params = {
      report_title: 'PD Session Summary',
      report: 'pdSessionSummary',
      filters,
    };

    if (report) {
      params.report_title = report.title;
      params.report = report.report;
    }

    return this.apiService
      .postRequest('reporting/queue-report-download', params)
      .pipe(map((res: boolean) => res));
  }
}
